(function($) {
    'use strict';
    $(function() {
        var $form = $('#extractorForm');
        var $format = $form.find('select[name="reportFormat"]');
        var $rules = $form.find('.report-format-rules');
        function updateFormats() {
            var report = $form.find('input[name="report"]:checked').val();
            var supported = $rules.attr('data-default') || 'xlsx';
            $rules.find('[data-report]').each(function() {
                if ($(this).attr('data-report') === report) {
                    supported = $(this).attr('data-formats');
                }
            });
            var formats = supported.split(',');
            var previous = $format.val();
            $format.find('option').each(function() {
                var unavailable = this.value !== '' && formats.indexOf(this.value) < 0;
                $(this).prop('disabled', unavailable).prop('hidden', unavailable);
            });
            if (formats.length === 1) {
                $format.val(formats[0]);
            } else if (formats.indexOf(previous) < 0) {
                $format.val('');
            }
        }
        if ($form.attr('data-selected-report')) {
            $form.find('input[name="report"]').each(function() {
                $(this).prop('checked', this.value === $form.attr('data-selected-report'));
            });
        }
        $form.on('change', 'input[name="report"]', updateFormats);
        updateFormats();

        var $reports = $('#generatedReports');
        // A dump whose job died (e.g. server restart) never completes, so stop polling once it is this old.
        // data-age-ms is computed server-side at render time, so client clock skew does not matter.
        var MAX_PENDING_MS = 5 * 60 * 1000;
        var pageLoadedAt = Date.now();
        function isStalled($row) {
            var age = parseInt($row.attr('data-age-ms'), 10);
            return (isNaN(age) ? 0 : age) + (Date.now() - pageLoadedAt) >= MAX_PENDING_MS;
        }
        function popup($row) {
            var trigger = $row.find('.report-trigger')[0];
            if (!trigger) {
                return;
            }
            initializePopover(trigger, {
                trigger: 'hover focus',
                html: true,
                content: function() {
                    var details = $row.find('.report-details')[0].cloneNode(true);
                    details.classList.remove('d-none');
                    var reason = $row.attr('data-failure-message');
                    if (reason) {
                        var error = document.createElement('p');
                        error.className = 'text-danger mb-0';
                        error.textContent = reason;
                        details.appendChild(error);
                    }
                    return details;
                }
            });
        }
        function poll($row) {
            if ($row.attr('data-pending') !== 'true') {
                return;
            }
            if (isStalled($row)) {
                $row.attr('data-pending', 'false');
                $row.find('.report-state').text($reports.attr('data-stalled')).addClass('text-danger');
                return;
            }
            $.ajax({
                url: $reports.attr('data-status-url'),
                data: {dumpId: $row.attr('data-dump-id')},
                dataType: 'json',
                timeout: 15000,
                success: function(result) {
                    var $state = $row.find('.report-state');
                    $state.removeClass('text-danger');
                    if (result.status === 'COMPLETE') {
                        var $old = $row.find('.report-trigger');
                        var instance = bootstrap.Popover.getInstance($old[0]);
                        if (instance) {
                            instance.dispose();
                        }
                        var $link = $('<a>').addClass('dump report-trigger')
                            .attr('tabindex', '0').attr('title', 'Report Details')
                            .attr('data-bs-toggle', 'popover')
                            .attr('href', $reports.attr('data-download-url') + '?dumpId=' + $row.attr('data-dump-id'));
                        $link.append($old.contents());
                        $old.replaceWith($link);
                        $row.find('.report-icon').removeClass('fa-clock fa-exclamation-circle').addClass('fa-arrow-circle-down');
                        $row.attr('data-pending', 'false').attr('data-failure-message', '');
                        $state.text('');
                        $reports.find('.report-announcement').text($reports.attr('data-complete'));
                        popup($row);
                    } else if (result.status === 'FAILED') {
                        $row.attr('data-pending', 'false').attr('data-failure-message', result.message);
                        $row.find('.report-icon').removeClass('fa-clock').addClass('fa-exclamation-circle');
                        $state.text($reports.attr('data-failed')).addClass('text-danger');
                        popup($row);
                    } else {
                        $state.text($reports.attr('data-progress'));
                    }
                },
                error: function(xhr, textStatus) {
                    // An expired session returns 401, or redirects to the HTML login page, which fails to parse as JSON.
                    var html = /text\/html/i.test(xhr.getResponseHeader('Content-Type') || '');
                    if (xhr.status === 401 || (textStatus === 'parsererror' && html)) {
                        $row.attr('data-pending', 'false');
                        $row.find('.report-state').text($reports.attr('data-session-expired')).addClass('text-danger');
                        return;
                    }
                    var message = xhr.responseJSON && xhr.responseJSON.message;
                    $row.find('.report-state').text(message || $reports.attr('data-status-error')).addClass('text-danger');
                    if (xhr.status === 403 || xhr.status === 404) {
                        $row.attr('data-pending', 'false');
                    }
                },
                complete: function() {
                    if ($row.attr('data-pending') === 'true') {
                        setTimeout(function() { poll($row); }, 5000);
                    }
                }
            });
        }
        $reports.find('.report-row').each(function() {
            var $row = $(this);
            popup($row);
            poll($row);
        });
    });
})(jQuery);
